import {createPortal} from 'react-dom';
import {Component, useEffect} from 'react';
import {useModelContext} from './modalContext';
import styled from 'styled-components';

const rootDOM = document.getElementById('root');
const bodyDOM = document.body;

const ModalStyles = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: var(--level3);
`;

const ModalContainer = ({children, ...props}) => {
  const {isShow } = useModelContext();
  useEffect(() => {
    if (isShow) {
      document.body.setAttribute('style', "overflow: hidden");
    } else {
      document.body.setAttribute('style', "");
    }
  }, [isShow]);
  if (!isShow) return null;
  return (
    <ModalStyles {...props}>
      {children}
    </ModalStyles>
  )
}


class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.el.id = 'modal';
  }
  componentDidMount() {
    bodyDOM.insertBefore(this.el, rootDOM.nextSibling);
  }
  componentWillUnmount() {
    bodyDOM.removeChild(this.el);
  }
  render() {
    return createPortal(
      <ModalContainer {...this.props}/>,
      this.el
    );
  }
}

export default Modal;
